export default defineNuxtPlugin((nuxtApp) => {
  const showConsentModal = () => {
    if (window && (window as any).CassieWidgetLoader) {
      (window as any).CassieWidgetLoader.Widget.showModal();
    }
  };

  const attachHandler = () => {
    const btn = document.getElementById("manualConsentoptout");
    if (btn) {
      btn.removeEventListener("click", showConsentModal);
      btn.addEventListener("click", showConsentModal);
    }
  };

  // attach after initial mount
  nuxtApp.hook("app:mounted", () => {
    attachHandler();
  });
});
